export default [
  {
    name: 'languages',
    path: '/languages',
    component: () => import(/* webpackChunkName: "languages" */ './Index.vue'),
    meta: {
      showNavbar: true,
      title: 'Idiomas',
      icon: 'dvr',
      label: 'Idiomas',
      permission: 'admin.languages.list'
    }
  }
]
